import React, { Component } from 'react';
import * as util from './util';
import {Header} from './header.js';
import {Footer} from './footer.js';

import './profile.css';

let faqProfile= [];

function FormGroup(props) {
  return (
    <div>
      <legend>{props.label}</legend>
      {props.children}
    </div>
  );
};

class LabeledInput extends Component {

  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.state = {
      value: props.value || '',
      checked: props.checked || false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value ||
        nextProps.checked !== this.state.checked) {
          this.setState({
            value: nextProps.value,
            checked: nextProps.checked,
          });
    }
  }

  handleOnChange(event) {
    const value = (event.target.tag === "checkbox")
                ? event.target.checked
                : event.target.value;
    this.setState({ value });
    this.props.onChange(event);
  }

  render() {
    return (
      <div className={"LabeledInput " + this.props.className}>
        <div className="Label">
          <label htmlFor={this.props.name}>{this.props.label}</label>
        </div>
        <div className="Input">
          <input type={this.props.type || "text"}
                 name={this.props.name || ""}
                 value={this.state.value}
                 onChange={this.handleOnChange}
                 disabled={this.props.disabled || false}
                 placeholder={this.props.placeholder || "" }
                 checked={this.state.checked || false }
                 required={this.props.required}
                 maxLength={this.props.maxLength} />
        </div>
      </div>
    );
  }
}

class LabeledCheckbox extends Component {

  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.state = {
      value: props.value || false
    }
  }

  componentWillReceiveProps(nextProps) {
    const value = nextProps.value;
    if (value !== this.state.value) {
      this.setState({ value });
    }
  }

  handleToggle() {
    this.setState({
      value: !this.state.value
    });
    this.props.onChange(!this.state.value);
  }

  render() {
    return (
      <LabeledInput className="LabeledCheckbox"
                    name={this.props.name}
                    label={this.props.label}
                    type="checkbox"
                    checked={this.state.value}
                    onChange={this.handleToggle}
                    disabled={this.props.disabled}
      />
    );
  }
}

class LabeledSelect extends Component {

  constructor(props) {
    super(props);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.state = {
      value: props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    const value = nextProps.value;
    if (value !== this.state.value) {
      this.setState({ value });
    }
  }

  handleSelectChange(event) {
    const value = event.target.value;
    this.setState({ value });
    this.props.onChange(event);
  }

  render() {
    const options = this.props.options.map((opt, i) => {
      if (typeof opt === 'object') {
        return (
          <option key={i} value={opt.value}>{opt.label}</option>
        );
      }
      else {
        return (
          <option key={i} value={opt}>{opt}</option>
        );
      }
    });
    return (
      <div className="LabeledInput LabeledSelect">
        <div className="Label">
          <label htmlFor={this.props.name}>{this.props.label}</label>
        </div>
        <div className="Input">
          <select className="InputSelect" name={this.props.name}
                  value={this.state.value}
                  defaultValue={this.props.defaultValue}
                  disabled={this.props.disabled}
                  onChange={this.handleSelectChange}
                  >
            {options}
          </select>
        </div>
      </div>
    );
  }
}

class ProfileForm extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      user_name: '',
      email: '',
      valid_email: false,
      company: '',
      department: '',
      street: '',
      street_number: '',
      additional_address: '',
      city: '',
      zip_code: '',
    };
  }

  componentDidMount() {
    const url = `/api/profile/${this.props.userName}`;
    fetch(url, {
      headers: util.defaultHeaders()
    })
      .then(resp => resp.json())
      .then(json => this.setState(json));
  }

  handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const url = `/api/profile/${this.props.userName}`;
    fetch(url, {
      method: "PUT",
      headers: util.defaultHeaders(),
      body: JSON.stringify(this.state),
    })
      .then(resp => resp.json())
      .then(json => {
        if (json.success) {
          alert('Profil aktualisiert');
          this.props.history.push('/product-list');
        }
        else {
          console.error('ProfileForm: Profile update failed');
        }
      });
  }

  render() {
    
    return (
     

      <div className="ProfileForm">
             <div className="content" id="content">
               <div className="productHeader1">
               Profildaten ändern
               </div>

        <form onSubmit={this.handleSubmit}>
          <div className="marginTop50 ProfilData">
          <FormGroup >
            <LabeledInput name="user_name"
                          label="Foren-Nutzername"
                          type="text"
                          value={this.state.user_name}
                          disabled={true}
                          maxLength={50}/>
            <LabeledInput name="email"
                          label="Email-Adresse"
                          type="text"
                          value={this.state.email}
                          disabled={true}
                          maxLength={200} />
            <LabeledCheckbox name="email_valid"
                             label="Email aktiviert"
                             value={this.state.valid_email}
                             disabled={true} />
            <LabeledInput name="first_name"
                          label="Vorname"
                          type="text"
                          value={this.state.first_name}
                          onChange={this.handleInputChange}
                          maxLength={30}/>
            <LabeledInput name="last_name"
                          label="Nachname"
                          type="text"
                          value={this.state.last_name}
                          onChange={this.handleInputChange}
                          maxLength={30} />
            <LabeledInput name="company"
                          label="Firma"
                          type="text"
                          value={this.state.company}
                          onChange={this.handleInputChange}
                          maxLength={30} />
            <LabeledInput name="department"
                          label="Abteilung"
                          type="text"
                          value={this.state.department}
                          onChange={this.handleInputChange}
                          maxLength={50} />
            <LabeledInput name="street"
                          label="Straße"
                          type="text"
                          value={this.state.street}
                          onChange={this.handleInputChange}
                          maxLength={50} />
            <LabeledInput name="street_number"
                          label="Hausnummer"
                          value={this.state.street_number}
                          onChange={this.handleInputChange}
                          maxLength={10} />
            <LabeledInput name="additional_address"
                          label="Adresszusatz"
                          type="text"
                          value={this.state.additional_address}
                          onChange={this.handleInputChange}
                          maxLength={30}/>
            <LabeledInput name="zip_code"
                          label="Postleitzahl"
                          value={this.state.zip_code}
                          onChange={this.handleInputChange}
                          maxLength={10}/>
            <LabeledInput name="city"
                          label="Stadt"
                          type="text"
                          value={this.state.city}
                          onChange={this.handleInputChange}
                          maxLength={30}/>
            <LabeledSelect name="country"
                           label="Land"
                           value={this.state.country}

                           options={['Deutschland','Österreich','Liechtenstein','Belgien','Italien',
                                     'Schweiz','Luxemburg','Dänemark','Polen','Frankreich','England']}
                           onChange={this.handleInputChange} />
          
          </FormGroup>
          </div>
          <div className="marginTop10 ToEndRightV2">
              <div onClick={this.handleSubmit}>
                <input className="buttonInput" type="submit" value="Übernehmen"/>
              </div>
            </div>
        </form>
        </div>
        </div>
    );
  }
}

class ProfileChangePasswordForm extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.errorMessages = {
      wrong_password: 'Passworteingabe falsch.',
      password_mismatch: 'Passwörter stimmen nicht überein.'
    };

    this.state = {
      current_password: '',
      new_password: '',
      new_password_verify: '',
      error: {
        required_fields: []
      },
    };
  }

  componentDidMount () {
    if ('oldPassword' in this.props.match.params)
      this.setState({current_password: this.props.match.params.oldPassword});
  }

  handleSubmit(event) {
    event.preventDefault();
    fetch('/api/change-password',  {
      method: 'POST',
      headers: util.defaultHeaders(),
      body: JSON.stringify(this.state)
    })
      .then(resp =>
        resp.json().then(json => {
          if (resp.status >= 400) {
            this.setState(json);
          }
          else {
            this.props.history.replace('/product-list');
          }
        })
      );
  }

  handleInputChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value
    });
  }

  markError(name) {
    return this.state.error.required_fields.includes(name)
         ? 'red'
         : '';
  }

  render() {
    return (
      <div className="ProfilePassword">
      <div className="content" id="content2">
      <div className="productHeader1">
               Passwort ändern
               </div>
        <div className="ProfilData marginTop30">
        <form onSubmit={this.handleSubmit}>
          <FormGroup >
            {this.state.error.message_flag !== undefined &&
             <p className="red">{this.errorMessages[this.state.error.message_flag]}</p>}
             <LabeledInput name="current_password"
                           label="Altes Passwort"
                           type="password"
                           className={this.markError('current_password')}
                           required={true}
                           value={this.state.current_password}
                           onChange={this.handleInputChange} />
             <LabeledInput name="new_password"
                           label="Neues Passwort"
                           type="password"
                           className={this.markError('new_password')}
                           required={true}
                           value={this.state.new_password}
                           onChange={this.handleInputChange} />
             <LabeledInput name="new_password_verify"
                           label="Neues Passwort wiederholen"
                           type="password"
                           className={this.markError('new_password_verify')}
                           required={true}
                           value={this.state.new_password_verify}
                           onChange={this.handleInputChange} />
           

          </FormGroup>
        </form>
      </div>
     
      <div className="marginTop10 ToEndRightV2">
               <div className=""  onClick={this.handleSubmit}>
                 <input className="buttonInput" value="Passwort ändern" type="submit" />
               </div>
             </div>
        </div>
      </div>
    );
  }
}

export class ProfilePage extends Component {
  constructor(props) {
    super(props);
    const userName = JSON.parse(localStorage.getItem('user')).username;
    this.state={userName: userName}
  }

  render() {
    if (util.isGuestUser()) {
      return (
        <div className="Landing">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
            <div className="content" id="content">

              <div className="contentHeaderText">
                Für nicht eingeloggte Nutzer ist die Seite nicht sichtbar.
           </div>
            </div>
          </div>
          {/*  <InfoBar faq={faqProfile} />*/}
        </div>
      )
    } else {
      return (
      <div className="Landing" id="contentId">
      <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
      <div className="ContentWithBackground">
        <ProfileForm userName={this.state.userName} history={this.props.history} />
        <ProfileChangePasswordForm history={this.props.history} match={this.props.match} userName={this.state.userName} />
        </div>
       <Footer faqs={faqProfile}/>
      </div>
    );
  }
}
}



// WEBPACK FOOTER //
// ./src/profile.js